/**
 * Área ACESSO: a pergunta de entrada do painel, "esta conta é usuária do painel?".
 *
 * Cobre UMA chamada do legado, `admin.html:3497`. A gestão de usuários do painel (listar, remover,
 * criar pela Edge Function `criar-usuario-sistema`, `admin.html:8825`, `8870` e `8896`) é da área
 * de Sistema, e não daqui: esta área existe só porque a tela de entrada precisa dela antes de
 * qualquer outra.
 */

// Tudo que uma área usa vem do núcleo, e de mais lugar nenhum (ver PADRAO.md).
import { clienteDe, executar, type FonteDeDados, type LinhaUsuariosSistema, type Resultado } from '../nucleo.js';

/** A linha que a entrada lê: só o e-mail e o papel, como o legado pede. */
export type AcessoDoUsuario = Pick<LinhaUsuariosSistema, 'email' | 'papel'>;

/**
 * Lê a própria linha em `usuarios_sistema` pelo e-mail da sessão.
 * Legado: `admin.html:3497`, `.select('email, papel').eq('email', ...).maybeSingle()`.
 *
 * `dados` nulo é "não é usuária do painel", e não falha: a linha pode legitimamente não existir,
 * e por isso a leitura é `maybeSingle`. A policy `usuarios_sistema_self_check` deixa cada
 * autenticado ler só a própria linha, então a pergunta funciona antes de se saber a resposta.
 */
export function lerAcessoPorEmail(fonte: FonteDeDados, email: string): Promise<Resultado<AcessoDoUsuario | null>> {
  return executar<AcessoDoUsuario | null>(
    clienteDe(fonte).from('usuarios_sistema').select('email, papel').eq('email', email).maybeSingle(),
  );
}
